import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loginUserByAPI } from "@/components/api/user";
import ToastProvider from "@/hooks/useToastProvider";
import { ValueProps, defaultValue } from "@/utils/interface.global";

export const loginUser = createAsyncThunk(
    "user/login",
    async (
        { codeStore, password }: ValueProps,
        { rejectWithValue, fulfillWithValue }
    ) => {
        try {
            const props = { codeStore, password };
            const response = await loginUserByAPI(props);
            console.log("response", response)
            if (response.status) {
                ToastProvider({ type: "success", content: "Đăng ký thành công" });
                return fulfillWithValue(response);
            } else {
                ToastProvider({ type: "error", content: response.message });
                throw rejectWithValue(response.message);
            }
        } catch (error) {
            throw rejectWithValue((error as DOMException).message);
        }
    }
);

const userSlice = createSlice({
    name: "user",
    initialState: { status: false, userData: {}, error: "" },
    reducers: {
        updateData: (state, action) => {
            state.userData = action.payload;
        },
        logout: (state) => {
            state.userData = {};
            state.status = false;
        },
    },
    extraReducers(builder) {
        builder
            // register user
            .addCase(loginUser.fulfilled, (state, action) => {
                state.status = true;
                state.userData = action.payload.data;
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.status = false;
                state.userData = [];
                state.error = action.payload as string;
            });
    },
});

//Reducers
export const { logout, updateData } = userSlice.actions;

// actions
//export const getUserData = (state) => state.user?.userData;
export const getUserData = (state: { user: { userData: defaultValue } }) => state.user?.userData;
export const getUserStatus = (state: { user: { status: string } }) => state.user?.status;
export const getUsertErr = (state: { user: { error: string } }) => state.user?.error;

// reducer
export default userSlice.reducer;